<template>
    <div class="settings-booking">
        <div class="booking">
            <v-row no-gutters>
                <v-col cols="6" md="4">
                    <div class="field-group">
                        <p class="custom-label">{{ $page.props.lang.cancelation_hours || "Hours before class customers can no longer cancel their reservation" }}</p>
                        <v-text-field v-model="bookingSettingsData.cancelation_hours" 
                        background-color="#FFFFFF" solo outlined flat dense
                        :error-messages="responseErrors.cancelation_hours" @focus="responseErrors.cancelation_hours=''"></v-text-field>
                    </div>
                    <div class="field-group">
                        <p class="custom-label">{{ $page.props.lang.close_reservations || "How soon before class customers can no longer make a reservation" }}</p>
                        <v-text-field v-model="bookingSettingsData.close_reservations" 
                        background-color="#FFFFFF" solo outlined flat dense
                        :error-messages="responseErrors.close_reservations" @focus="responseErrors.close_reservations=''"></v-text-field>
                    </div>
                    <div class="field-group">
                        <p class="custom-label">{{ $page.props.lang.future_reservation_days_limit || "How many days into the future do you want to allow customers to make reservations" }}</p>
                        <v-text-field v-model="bookingSettingsData.future_reservation_days_limit" 
                        background-color="#FFFFFF" solo outlined flat dense
                        :error-messages="responseErrors.future_reservation_days_limit" @focus="responseErrors.future_reservation_days_limit=''"></v-text-field>
                    </div>
                    <div class="column button-wrap">
                        <v-btn @click="saveBookingSettings" color="primary" width="160">
                            {{ $page.props.lang.save || 'Save' }}
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import SettingsLayout from '@/js/Layouts/SettingsLayout'
import EventBus from '@/js/eventbus'

export default {
    layout: (h, page) => {
      return h(AppLayout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.booking_settings || "Booking"
        }
    },
    props: {
        lang: Object,
        booking_settings: Object
    },
    data(){
        return {
            bookingSettingsData: this.booking_settings,
            responseErrors: {}
        }
    },
    methods: {
        saveBookingSettings() {
            let bookingSettingsPack = {}
            bookingSettingsPack = {
                cancelation_hours: this.bookingSettingsData.cancelation_hours,
                close_reservations: this.bookingSettingsData.close_reservations,
                future_reservation_days_limit: this.bookingSettingsData.future_reservation_days_limit,
            }
            axios.post('/backoffice/settings/saveBookingSettings', bookingSettingsPack)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.$inertia.reload({only:['booking_settings']})
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        },
    }
}
</script>